import {
  param2Obj
} from '@/utils'

// 本地局域网地址
// const LOCAL_AREA_NETWORK_IMG_URL = 'https://hr_local_cdn.ainfinit.com/cache/img?url='
// 全局引用方法
export default {
  data() {
    return {
      ossImgurl: 'https://static.ainfinit.com/static/crowdsource-user',
      localThat: this,
      /**
       * 异常原因
       * 注：标注在初次做完后 后端会处理并存到标注表和订单表 此时标注与订单图片的异常原因相同 管理端处理标注全部用图片就可以
       * taskFlag 0: 视频  0无异常 | 3放入异物 | 6非友好操作 | 7视频异常 | 5无法处理 | 4商品不在模板
       * taskFlag 1: 图片  0无异常 | 5无法处理
       * taskFlag 2: 标注  0无异常 | 2无法处理
       */
      abnormalReasonData: [
        { value: 0, label: '无异常', taskFlag: '0,1,2' },
        { value: 3, label: '放入异物', taskFlag: '0' },
        { value: 6, label: '非友好操作', taskFlag: '0' },
        { value: 7, label: '视频异常', taskFlag: '0' },
        { value: 2, label: '无法处理', taskFlag: '2' }, // 标注
        { value: 5, label: '无法处理', taskFlag: '0,1' },
        // { value: 1, label: '商品不在模板', taskFlag: '2' }, // 标注
        { value: 4, label: '商品不在模板', taskFlag: '0' }
      ]
    }
  },
  computed: {
    // 是否使用局域网的图片缓存
    useLocalAreaNetworkCache() {
      return this.$store.state.common.useLocalAreaNetworkCache
    }
  },
  filters: {
    filterLocalAreaNetworkResetUrl: function(url, that) {
      // 打印信息
      // console.log(that.useLocalAreaNetworkCache ? (that.useLocalAreaNetworkCache + url) : url)
      // 可以使用
      if (that.useLocalAreaNetworkCache) {
        return that.useLocalAreaNetworkCache + '/cache/img?url=' + url
      } else {
        return url + '?x-oss-process=image/resize,m_mfit,h_150,w_150'
      }
    }
  },
  // v-tab-change:activeName="setActiveName"
  directives: {
    // 计算是否滚动到最下面
    'tab-change': {
      bind(el, binding) {
        const param = param2Obj(window.location.href)
        if (param.active) {
          binding.value({
            action: 'setActiveName',
            key: binding.arg
          }, param.active)
        }
      },
      update(el, binding) {
        setTimeout(() => {
          const param = param2Obj(window.location.href)
          const queryList = document.querySelectorAll('.el-tabs__item')
          for (let index = 0; index < queryList.length; index++) {
            const item = queryList[index]
            if (item.className.indexOf('is-active') !== -1) {
              const activeName = item.id.split('-')[1]
              // 防止重复调用push方法
              if (param.active !== activeName) {
                binding.value({
                  action: 'setPath'
                }, activeName)
              }
            }
          }
        }, 0)
      }
    }
  },
  methods: {
    setActiveName({
      action,
      key
    }, activeName) {
      // 写入tabs默认值
      if (action === 'setActiveName') {
        this[key] = activeName
      } else {
        this.$router.replace({
          query: {
            ...this.$route.query,
            active: activeName
          }
        })
      }
    },
    successNotify(message, duration = 2000) {
      this.$notify({
        title: '成功',
        message,
        type: 'success',
        duration: duration
      })
    },
    errorNotify(message, duration = 2000) {
      this.$notify({
        title: '失败',
        message,
        type: 'error',
        duration: duration
      })
    },
    // 数字1-7转为中文数字
    toChinesNum(num) {
      num = parseInt(num)
      const changeNum = ['一', '二', '三', '四', '五', '六', '日']
      return changeNum[num]
    },
    /**
     * 重写写入地址
     * @param {*} url 地址
     * @returns url 地址
     */
    localAreaNetworkResetUrl(url) {
      console.log(this.useLocalAreaNetworkCache ? (this.useLocalAreaNetworkCache + url) : url)
      // 可以使用
      if (this.useLocalAreaNetworkCache) {
        return this.useLocalAreaNetworkCache + '/cache/img?url=' + url
      } else {
        return url + '?x-oss-process=image/resize,m_mfit,h_150,w_150'
      }
    }
  }
}
